import { insertGTMScript } from './google_tag_manager';
insertGTMScript();